export function orderTypeMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      orderTypeId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateOrderTypeId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}
export function fixGetManyOrderTypes(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateOrderTypeId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function orderTypeMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, orderTypeId: json.result.objectId},
  };
}